// extracted by mini-css-extract-plugin
export default {"list":"Pagination_list__t7oBK","activeButton":"Pagination_activeButton__+fU2n","disableButton":"Pagination_disableButton__wyrgb"};